import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MsalService } from 'src/app/msal';
import { HomeService } from 'src/app/service/home.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnAuthorizedComponent implements OnInit {
  constructor(private route: ActivatedRoute, public router: Router, private authService: MsalService,
    private homeService: HomeService) {
  }
  isFromFVM: boolean;
  isFromCommon: boolean;
  paramError: any;
  paramLogout: any;
  msg: string;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {(
      this.paramError = params['error'],
      this.paramLogout = params['logout']);
    });
    if(this.paramError != undefined) {
      this.isFromFVM = this.paramError == 'fvm' ? true : false;
      this.isFromCommon = !this.isFromFVM;
      if (this.isFromCommon) { this.msg = "Something went wrong, Please Contact System Administrator." }
      else { this.msg = "Not Authorized In FVM. Please Contact FVM Support." }
    }
    if (this.paramLogout === 'true') {
      setTimeout(() => {
        localStorage.clear();
        sessionStorage.clear();
        this.authService.logout();
      }, 3000);
    }
    else {
      setTimeout(() => {
        localStorage.setItem('currentIndex', '0');
        this.router.navigate(['/home']);
        this.homeService.updateMenuHighlight.emit('home')
      }, 5000);
    }
  }
  
}